import React from 'react';
import './FloatingPlusButton.css';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Shared FloatingPlusButton Component
 * Issue #230: Floating plus button for quick content creation
 *
 * A 35x35px circular button positioned at the bottom-right corner,
 * above the navigation bar. Used for quick navigation to create pages.
 *
 * @param {Function} onClick - Click handler for the button
 * @param {String} ariaLabel - Custom aria-label (optional, uses translation if not provided)
 */
const FloatingPlusButton = ({ onClick, ariaLabel }) => {
  const { t } = useLanguage();

  return (
    <button
      type="button"
      className="floating-plus-button"
      onPointerDown={onClick}
      aria-label={ariaLabel || t('floatingPlusButton.ariaLabel') || 'Neuen Inhalt erstellen'}
    >
      {/* Plus icon using SVG for crisp rendering */}
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ pointerEvents: 'none' }}
      >
        <path
          d="M9 1V17M1 9H17"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default FloatingPlusButton;
